module.exports = __webpack_public_path__ + "static/1-3e3af2cef834bcc3fb181e68898862e4.jpg";